import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getStringTypeProps } from '@blaze-cms/utils/src/helpers';
import getGenericRenderVariables from './get-generic-render-variables';
import buildRawQueryBase from './build-raw-query-base';
import buildSetFilters from './build-set-filters';
import { DEFAULT_LIMIT } from '../constants';
const filterQuerySetup = ({
  getEntitySchemas,
  entity,
  updatedFilterBy,
  variableProps,
  docType,
  filterOperator,
  filterEntityRelations,
  itemsToDisplay,
  entitySameAsCurrentItemEntity,
  entitySchema,
  useRandomSort = false
}) => {
  const stringProps = getStringTypeProps(entity, filterEntityRelations, getEntitySchemas);
  const filterValues = updatedFilterBy && updatedFilterBy.length ? buildSetFilters(_objectSpread(_objectSpread({}, variableProps), {}, {
    filterBy: updatedFilterBy
  })) : buildSetFilters(variableProps);
  const rawQuery = {
    bool: buildRawQueryBase({
      docType,
      filterValues,
      filterOperator,
      relations: filterEntityRelations,
      stringProps,
      itemsToDisplay,
      addListFiltersToQuery: true,
      entity,
      entitySchema
    })
  };

  // increase limit to get extra item in case results contain current parent
  const {
    limit: settingsLimit
  } = variableProps;
  const limit = settingsLimit || DEFAULT_LIMIT; // all falsey should use default
  const requestLimit = entitySameAsCurrentItemEntity ? Number(limit) + 1 : limit;
  const variables = getGenericRenderVariables({
    relations: filterEntityRelations,
    filterProps: _objectSpread(_objectSpread({}, variableProps), {}, {
      limit: requestLimit
    }),
    stringProps,
    rawQuery,
    useRandomSort
  });
  return {
    variables,
    limit
  };
};
export default filterQuerySetup;
//# sourceMappingURL=filter-query-setup.js.map